import { render, staticRenderFns } from "./GroupListRow.vue?vue&type=template&id=2aa58722&"
import script from "./GroupListRow.vue?vue&type=script&lang=ts&"
export * from "./GroupListRow.vue?vue&type=script&lang=ts&"
import style0 from "./GroupListRow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VListItem,VListItemAction,VListItemContent,VListItemSubtitle,VListItemTitle})
